<template>
  <div class="wrap">
    <div class="join">
      <div class="container">
        <div class="join_wrap">
          <!-- <div class="join_title">회원 가입 유형 선택</div> -->
          <div class="join_title">본인인증 선택</div>
          <div class="join_type">
            <div class="con_box" @click="joinTryOacx">
              <img src="/assets/images/layout/certification_easy.png" />
              <span>간편인증</span>
            </div>

            <!-- <div class="con_box" @click="confirmStep">
              <span>다음페이지</span>
            </div> -->
            <div class="con_box" @click="joinTryCivs">
              <img src="/assets/images/layout/certification_card.png" />
              <span>카드본인확인</span>
            </div>
            <form ref="reqCIVSForm"></form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="Modals">
    <ModalAlertJoin
      :alertMsg="errMsg"
      :isOpen="errStatus"
      :endJoin="joinTrigger"
      @update:isOpen="updateStatus"
    />
  </div>
</template>

<script>
import { ref, onUnmounted } from 'vue'
import { loadOacxPopup } from '../api/loginout'
import { joinWithOacx, loadCivsPopup, joinWithCivs } from '../api/join'
import ModalAlertJoin from './ModalAlertJoin.vue'

export default {
  name: 'JoinStepCertification',
  components: {
    ModalAlertJoin,
  },
  emits: ['nextStep'],
  setup(props, { emit }) {
    const oacxData = ref('')
    const civsData = ref('')
    const errMsg = ref('')
    const errStatus = ref(false)
    const joinTrigger = ref('fail')
    const reqCIVSForm = ref(null)

    let oacxStatusCheck = null

    const oacxStop = () => {
      clearInterval(oacxStatusCheck)
      oacxStatusCheck = null
    }
    const confirmStep = () => {
      emit('nextStep')
    }
    const updateStatus = () => {
      errStatus.value = false
    }
    const joinTryOacx = async () => {
      try {
        oacxData.value = await loadOacxPopup()
        const oacxWindow = window.open(
          '/oacx',
          'OacxPopupViews',
          'width=800,height=728'
        )
        if (oacxWindow === null) {
          alert(
            ' ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.'
          )
          return
        }
        if (oacxData.value.code === 'MB32000200') {
          localStorage.setItem('baseUrl', oacxData.value.content.popup_base_url)
          localStorage.setItem('certInfo', oacxData.value.content.cert_info)
          localStorage.setItem(
            'callbackUrl',
            oacxData.value.content.callback_url
          )
          localStorage.setItem('sid', oacxData.value.content.sid)
          localStorage.setItem('chkPoint', 'trigger')
        }
        // eslint-disable-next-line consistent-return
        const handleMessage = async (event) => {
          if (event.data === 'popupClosed') {
            const getResult = await joinWithOacx()
            console.log(getResult)
            if (getResult && getResult.status_code) {
              if (getResult.code === 'MB12103400') {
                errMsg.value =
                  '이미 가입한 계정이 있습니다.<br>이전에 가입한 계정을 확인해주세요.'
                errStatus.value = true
                joinTrigger.value = 'dupMember'
                clearInterval(oacxStatusCheck)
              }
              if (getResult.code !== 'MB12100200') {
                return 0
              }
              confirmStep()
            }
            if (event.origin !== window.location.origin) {
              return 0
            }
            if (event.data === 'popupClosed') {
              window.removeEventListener('message', handleMessage)
            }
            window.removeEventListener('message', handleMessage)
          }
        }
        // eslint-disable-next-line consistent-return
        window.addEventListener('message', handleMessage)
      } catch (err) {
        console.log(err)
      }
    }

    // eslint-disable-next-line consistent-return
    const joinTryCivs = async () => {
      reqCIVSForm.value.reset() // 폼 내부의 데이터를 초기화
      reqCIVSForm.value.innerHTML = '' // 폼 내부의 요소들 제거
      try {
        civsData.value = await loadCivsPopup()
        const windowOpts =
          'width=430px, height=725px, scrollbars=yes, resizable=yes, menubar=no, toolbar=no, location=no, status=no, titlebar=0, '
        const position = 'left=10px, top=10px'
        const civsWindow = window.open(
          '/civs',
          'CivsPopupViews',
          windowOpts + position
          // `${windowOpts}, ${position}`
        )
        if (civsWindow === null) {
          alert(
            ' ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.'
          )
          return
        }
        if (civsData.value.code === 'MB31000200') {
          localStorage.setItem('sid', civsData.value.content.sid)
        }

        reqCIVSForm.value.method = 'post'
        reqCIVSForm.value.action = `${civsData.value.content.cert_url}/check`
        reqCIVSForm.value.target = 'CivsPopupViews'

        const createHiddenField = (name, value) => {
          const hiddenField = document.createElement('input')
          hiddenField.setAttribute('type', 'hidden')
          hiddenField.setAttribute('name', name)
          hiddenField.setAttribute('value', value)
          reqCIVSForm.value.appendChild(hiddenField)
        }

        createHiddenField('certInfo', civsData.value.content.cert_info)
        createHiddenField('nr', 'false')

        reqCIVSForm.value.submit()

        // eslint-disable-next-line consistent-return
        const handleMessage = async (event) => {
          if (event.data === 'popupClosed') {
            reqCIVSForm.value.reset()
            reqCIVSForm.value.innerHTML = ''
            const getResult = await joinWithCivs()
            console.log(getResult)
            if (getResult && getResult.status_code) {
              if (getResult.code === 'MB12103400') {
                errMsg.value =
                  '이미 가입한 계정이 있습니다.<br>이전에 가입한 계정을 확인해주세요.'
                errStatus.value = true
                joinTrigger.value = 'dupMember'
              }
              if (getResult.code !== 'MB12100200') {
                return 0
              }
              // alert('개발자모드 끔')
              confirmStep()
              // "MB12101404" 본인확인이 완료되지 않았습니다.
            }
            if (event.origin !== window.location.origin) {
              return 0
            }
            if (event.data === 'popupClosed') {
              window.removeEventListener('message', handleMessage)
            }
          }
        }
        // eslint-disable-next-line consistent-return
        window.addEventListener('message', handleMessage, { once: true })
      } catch (error) {
        console.error('Request failed:', error)
      }
    }
    onUnmounted(() => {
      clearInterval(oacxStatusCheck)
    })

    return {
      oacxStop,
      joinTryOacx,
      reqCIVSForm,
      joinTryCivs,
      confirmStep,

      errMsg,
      errStatus,
      joinTrigger,
      updateStatus,
    }
  },
}
</script>

<style></style>
